module.exports = __webpack_public_path__ + "img/banner_desktop.19c817ce.jpg";